import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  getSubscriptionDetailRequest,
  getSubscriptionDetailRequestSuccess,
  getSubscriptionDetailRequestError,
} from "../../../slices/teams/members/GetSubscriptionDetailsSlice";

export const GetSubscriptionById = (id) => async (dispatch) => {
  try {
    dispatch(getSubscriptionDetailRequest());

    const response = await axiosInstance.get(
      `${endpoints.getSubscriptionDetail}/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    dispatch(getSubscriptionDetailRequestSuccess(response?.data));
    return response?.data;
  } catch (error) {
    const _error = {
      data: error?.response?.data?.message || error?.message,
      status: error?.response?.status || error?.status,
    };
    dispatch(getSubscriptionDetailRequestError(_error));
    throw _error;
  }
};
